import { SpecializedSingleSelectFilterProps } from "@components/job_search/filters/single_select_filter.tsx";
import Button from "@sprout/button.tsx";
import CaretIcon from "@sprout/icons/caret.tsx";
import { RadioGroup, RadioGroupItem } from "@components/ui/radio-group.tsx";
import { Body, SectionTitle } from "@sprout/typography.tsx";
import { Drawer, DrawerContent, DrawerTrigger } from "@components/ui/drawer.tsx";
import { useState } from "react";

export const MobileSingleSelectFilter = ({
  buttonText,
  name,
  options,
  value,
  onValueChange,
}: SpecializedSingleSelectFilterProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleValueChange = (value: string) => {
    onValueChange(value);
    setIsOpen(false);
  };

  return (
    <Drawer open={isOpen} onOpenChange={() => setIsOpen(!isOpen)}>
      <DrawerTrigger asChild>
        <Button size="medium" className="inline-flex items-center justify-between gap-1">
          <div className="flex items-center justify-center gap-1 w-full">
            {buttonText}
            <CaretIcon size="sm" color="green" />
          </div>
        </Button>
      </DrawerTrigger>
      <DrawerContent className="gap-2">
        <SectionTitle>{name}</SectionTitle>
        <RadioGroup value={value} onValueChange={handleValueChange} className="flex flex-col gap-2">
          {options.map((option) => (
            <div key={option} className="flex items-center space-x-2 w-[197px]">
              <RadioGroupItem value={option} id={option} />
              <label htmlFor={option} className="cursor-pointer w-full">
                <Body secondary style={{ lineHeight: "24px" }}>
                  {option}
                </Body>
              </label>
            </div>
          ))}
        </RadioGroup>
      </DrawerContent>
    </Drawer>
  );
};
